import { DateTime } from 'luxon';
import { getUserLanguage } from '@teachino/shared-i18n';

export const formatDayAndTimeShort = (date: Date | string): string => {
  const dateTime =
    typeof date === 'string'
      ? DateTime.fromISO(date)
      : DateTime.fromJSDate(date);
  return dateTime.setLocale(getUserLanguage()).toFormat('ccc, dd.MM., HH:mm');
};

export function formatDateToMachineDate(date: Date): string {
  return DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
}

export function formatIsoDateTimeToMedium(isoDateTime: string): string {
  return DateTime.fromISO(isoDateTime).toLocaleString(DateTime.DATETIME_MED);
}

export function parseMachineDate(machineDate: string): Date {
  return DateTime.fromFormat(machineDate, 'yyyy-MM-dd').toJSDate();
}

export function formatDateToDayAndMonth(date: Date): string {
  // todo: how do locales work in teachino?
  return DateTime.fromJSDate(date).toFormat('EEEE, d. MMMM', { locale: 'de' });
}

export function formatDayShort(date: Date | string): string {
  const luxonDate =
    typeof date === 'string'
      ? DateTime.fromISO(date)
      : DateTime.fromJSDate(date);

  return luxonDate.toLocaleString({
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
}
